import { Box, List, ListItem, ListItemIcon, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import Looks5Icon from "@mui/icons-material/Looks5";
import Looks6Icon from "@mui/icons-material/Looks6";
export default function MeasurementViewIntro() {
  const { t } = useTranslation();

  const successfulMeasurement = [
    {
      icon: <LooksOneIcon color="primary" />,
      text: t("introductions.measurement.step1"),
    },
    {
      icon: <LooksTwoIcon color="primary" />,
      text: t("introductions.measurement.step2"),
    },
    {
      icon: <Looks3Icon color="primary" />,
      text: t("introductions.measurement.step3"),
    },
    {
      icon: <Looks4Icon color="primary" />,
      text: t("introductions.measurement.step4"),
    },
    {
      icon: <Looks5Icon color="primary" />,
      text: t("introductions.measurement.step5"),
    },
    {
      icon: <Looks6Icon color="primary" />,
      text: t("introductions.measurement.step6"),
    },
  ];

  return (
    <Box>
      <Box>
        <Typography fontSize={30} variant="h5">
          {t("introductions.measurement.text1")}
        </Typography>
      </Box>

      <Box mt={3}>
        <Typography>{t("introductions.measurement.text2")}</Typography>

        <Typography mt={1}>{t("introductions.measurement.text4")}</Typography>
      </Box>

      <Box mt={2}>
        <List disablePadding>
          {successfulMeasurement.map((s, i) => (
            <ListItem key={i} disableGutters>
              <ListItemIcon>{s.icon}</ListItemIcon>
              <Typography>{s.text}</Typography>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
